module.exports = __webpack_public_path__ + "static/VS_icon05-01-351c0e777daafbfae0684c99c64d4019.png";